<script setup lang="ts">
import { computed } from 'vue'

import { Incident } from '@collector/sportsapi-client'
import { Confirmation } from '@collector/sportsapi-client-legacy'

interface Props {
  incident: Incident
  isDeleted: boolean
}

const props = defineProps<Props>()

// computed
const confirmation = computed(() => {
  if (props.incident.confirmation === null) {
    return ''
  }

  return props.incident.confirmation
})

const isToBeDone = computed(
  () => props.incident.confirmation === Confirmation.ToBeDone,
)

const isConfirmed = computed(
  () => props.incident.confirmation === Confirmation.Confirmed,
)

const isCancelled = computed(
  () => props.incident.confirmation === Confirmation.Cancelled,
)
</script>

<template>
  <div
    v-if="confirmation"
    class="text-2xs pt-0.25 font-bold capitalize"
    :class="{
      'line-through': isDeleted,
      'text-neutral-dark-10 uppercase': isToBeDone,
      'text-success-3': isConfirmed && !isDeleted,
      'text-success-3/50': isConfirmed && isDeleted,
      'text-error-5': isCancelled && !isDeleted,
      'text-error-5/50': isCancelled && isDeleted,
    }"
  >
    <span>({{ confirmation }})</span>
  </div>
</template>
